import script from "./PayTarget.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayTarget.vue?vue&type=script&setup=true&lang=ts"

import "./PayTarget.vue?vue&type=style&index=0&id=115b2f31&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115b2f31"]])

export default __exports__